import { z } from 'zod'

export const SessionScreenshotSchema = z.object({
  url: z.string().url(),
  observation_timestamp: z.number().nonnegative(),
  frame_timestamp: z.number().nonnegative(),
})
export const SessionScreenshotResponseSchema = z.discriminatedUnion('status', [
  z.object({ status: z.literal('pending') }),
  z.object({ status: z.literal('unavailable') }),
  z.object({ status: z.literal('ready'), screenshot: SessionScreenshotSchema }),
])
export type SessionScreenshotResponse = z.infer<typeof SessionScreenshotResponseSchema>

export const SessionScreenshotRequestSchema = z.object({
  run_id: z.string().min(1).max(200),
  observation_id: z.string().uuid(),
})
export const SessionScreenshotJobSchema = z.object({ id: z.string().uuid() })
